// Centralised brand constants. Change once, update everywhere.
export const BRAND = {
    name: "Pax",         // capital — for headings, titles
    handle: "pax",       // lowercase — for casual text
    tagline: "a mental health companion",
    premiumLabel: "Pax Plus",
    description: "Pax is a mental health companion — a face, a voice, here to listen, reflect, and walk through your day beside you. Not a therapist, but a presence.",
    logo: "/pax-logo.png",
    fullName: "PaxMind AI",
};

export default BRAND;
